<script setup lang="ts">
import { computed } from 'vue'
import { PhCaretRight } from '@phosphor-icons/vue'

import { PurchaseOptions } from '@toni/commerce-api-types'

import PurchaseOptionLogo from '../PurchaseOptionLogo.vue'

const props = defineProps<{
  purchaseOption: PurchaseOptions[0]
}>()

const purchaseOption = computed(() => props.purchaseOption)

const {
  merchant,
  info: { detailPageUrl }
} = purchaseOption.value

const validMerchantData = computed((): boolean => {
  return !!(merchant.name && detailPageUrl)
})

</script>

<template>
  <a v-if="validMerchantData"
     :href="detailPageUrl"
     target="_blank"
     rel="noopener noreferrer sponsored"
     class="group rounded-lg border border-action-primary-background hover:border-highlight-primary-background flex justify-between w-full p-1 pl-1.5 gap-1">
    <PurchaseOptionLogo :merchant="merchant"
                        size="md"
                        class="mx-1 my-1.5 max-w-[4rem]" />
    <div class="lg:hidden flex items-center justify-center rounded-lg bg-action-primary-background group-hover:bg-highlight-primary-background text-action-primary-foreground min-w-[2.5rem] min-h-[2.5rem]">
      <PhCaretRight size="20" />
    </div>
    <div class="hidden lg:flex items-center justify-center rounded-lg bg-action-primary-background group-hover:bg-highlight-primary-background text-action-primary-foreground min-w-[2.5rem] min-h-[2.5rem] gap-1 px-3.5 text-sm font-button">
      <span>{{ $t('commerce.toTheOffer') }}</span><PhCaretRight size="20" />
    </div>
  </a>
</template>
